// extracted by mini-css-extract-plugin
module.exports = {"showCase":"Showcase_showCase__R5tu1","showcaseItemsContainer":"Showcase_showcaseItemsContainer__tQyN1","showcaseItemDescription":"Showcase_showcaseItemDescription__e1vct"};